import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { VisitPatientWithExternalIdentifier } from './types';

export const checkVisitPatientWithExternalIdentifier = (
   patient: VisitPatient
): patient is VisitPatientWithExternalIdentifier => {
   const externalIdentifier = patient.referenceIdentifier?.findExternalIdentifier();
   return Boolean(externalIdentifier);
};
